import { render, staticRenderFns } from "./court-customer.vue?vue&type=template&id=0c18f25e&scoped=true&"
import script from "./court-customer.vue?vue&type=script&lang=js&"
export * from "./court-customer.vue?vue&type=script&lang=js&"
import style0 from "./court-customer.vue?vue&type=style&index=0&id=0c18f25e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18f25e",
  null
  
)

export default component.exports